import {environment} from '../../environments/environment';

export class UserSetting {
  public isAdmin: boolean;
  public isOwner: boolean;
  public avatar: string;
  readonly created_at: string;
  public email: string;
  public group_id: number;
  public g_name: string;
  readonly id: number;
  public name: string;
  public updated_at: string;
  public username: string;
  public authority: Authority;

  constructor(data: any) {
    this.isAdmin = data.isAdmin;
    this.isOwner = data.isOwner;
    this.avatar = data.avatar ? environment.apiURL + '/storage/' + encodeURIComponent(data.avatar) : '';
    this.created_at = data.created_at;
    this.email = data.email;
    this.group_id = data.group_id;
    this.g_name = data.g_name;
    this.name = data.name;
    this.id = data.id;
    this.updated_at = data.updated_at;
    this.username = data.username;
    this.authority = new Authority(data.authority);
  }
}

export enum AuthorityUser {
  AU_1 = 1,
}

export class Authority {
  /** Room Vip */
  public AU_1: boolean;

  // Constructor
  // -----------------------
  constructor(authorities: number[]) {
    if (!authorities || authorities.length === 0) {
      this.AU_1 = false;
      return;
    }
    this.AU_1 = this.isAuthority(authorities, 1);
  }

  // Methods
  // -----------------------
  private isAuthority(authorities: number[], value: number): boolean {
    const authority = authorities.find(v => {
      return v === value;
    });
    return 0 < authority;
  }
}



// WEBPACK FOOTER //
// /app/src/app/models/user-setting.ts